<kodit-page>
  <kodit-table
    [tableConfig]="tableConfig"
    [items]="skladisneJediniceTable"
    [isTableLoading]="isLoading"
  ></kodit-table>
</kodit-page>
